import React, { useContext, useState } from 'react';
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import { useParams } from 'react-router-dom';

import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { Box, Button, Divider, Drawer, Typography } from '@mui/material';

import { RootState } from '../../../../app/rootReducer';
import { AppDispatch } from '../../../../app/store';
import { IconLink } from '../../../../common/components/IconLink';
import { NoraButton } from '../../../../common/components/v2';
import { Decision } from '../../../../common/constants/decision';
import { Resource } from '../../../../common/constants/resource';
import { resolveCarrierDecisionType } from '../../../../common/constants/roles';
import ElementLocators from '../../../../common/ElementLocators';
import { AuthContext } from '../../../login/AuthWrapper';
import { postDecision } from '../../decision/decisionSlice';
import { IDecisionRequest } from '../../interfaces/IDecisionRequest';
import styles from '../styles.module.scss';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default function AgreeToRescind() {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useContext(AuthContext);
  const detailedLifecycle = useSelector(
    state => state.application.applicationDetailedLifecycle,
  );
  const decisionType = resolveCarrierDecisionType(
    auth.roles,
    detailedLifecycle,
  );
  const { id } = useParams<{ id: string }>();
  const [isOpen, setIsOpen] = useState(false);

  if (!decisionType) {
    return null;
  }

  function onClick() {
    if (!id) {
      return;
    }
    const decision = {
      decision: Decision.DECLINED,
      decisionType,
      carrierUnderwriterName: auth.userName,
    } as IDecisionRequest;
    dispatch(postDecision(id, decision, true));
    setIsOpen(false);
  }

  return (
    <>
      <Drawer
        open={isOpen}
        anchor="right"
        variant="persistent"
        classes={{ paper: styles.Drawer }}
        transitionDuration={{ enter: 0, exit: 0 }}
      >
        <Box mt={6}>
          <Box
            m={3}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body1">{Resource.AGREE_TO_RESCIND}</Typography>
            <Button onClick={() => setIsOpen(false)}>
              <Typography variant="subtitle2" color="textSecondary">
                Cancel
              </Typography>
            </Button>
          </Box>
          <Divider />
        </Box>
        <Box>
          <NoraButton
            name={ElementLocators.LOCATOR_REVIEW_APPROVAL_BUTTON}
            className={styles.DrawerButton}
            onClick={onClick}
          >
            {Resource.CONFIRM_DECISION}
          </NoraButton>
        </Box>
      </Drawer>
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faCheck}
        copy={Resource.AGREE_TO_RESCIND}
        locator={ElementLocators.APPROVE_DECISION_LINK}
      />
    </>
  );
}
